const angular = require('angular');
const app = angular.module('learn-directives');
const moment = require('moment');
/**
 * Defines the Track Viewer component
 * @argument {Application} Application injected to gain access to the global Application functions and properties
 * @argument {Tracks} Tracks the resource defined to manage Tracks
 * @argument {UserTracks} UserTracks the resource defined to manage UserTracks
 */
app.directive('trackHost', ['Application', 'Authorization', 'Tracks', 'UserTracks', 'Analyze', 'Users', 'Assessments', 'AssessmentCharts', '$translate', function(Application, Authorization, Tracks, UserTracks, Analyze, Users, Assessments, AssessmentCharts, $translate) {
    return {
      restrict: 'E',
      scope: {
        fullData: '='
      },
      template: require('../../templates/directives/track-host.html'),
      controller: ['$scope', function($scope) {
          var self = this;
          self.courseDirectory = {};
          self.userNames = {};
          self.translations = {};
          self.engage = Authorization.getAuthToken().company && Authorization.getAuthToken().company.engage;
          var routeParameters = Application.navigation.getRouteParameters();
          self.trackId = routeParameters.id;
          var dropoffDate = moment().subtract(30, 'days');
          self.circleStats = {
            totalParticipants: 0,
            completedParticipants: 0,
            activeParticipants: 0,
            averageDuration: '--'
          };

          self.getProgress = function(amnt) {
            if (amnt !== 'unknown') {
              var style = {
                'width': amnt + '%'
              };
              return style;
            }
          };

          self.editMenu = {
            visible: false,
            activeId: null,
            closeHandler: function(){
              self.editMenu.visible = false;
              self.editMenu.activeId = null;
            },
            clickHandler: function(i){
              if (self.editMenu.visible) {
                if (self.editMenu.activeId === i) {
                  self.editMenu.visible = false;
                  self.editMenu.activeId = null;
                } else {
                  self.editMenu.activeId = i;
                }
              } else {
                self.editMenu.activeId = i;
                self.editMenu.visible = true;
              }
            }
          };

          self.predicate = {
            current: 'user.full_name',
            past: 'user.full_name',
            assigned: 'assignee.full_name'
          };

          self.reverse = {
            current: false,
            past: false,
            assigned: false
          };

          self.smart_filter = {};
          self.selectionDirectory = {};
          self.selections = {
            select: function(item) {
              var id = item._id;
              if (self.selectionDirectory[id]) {
                delete self.selectionDirectory[id];
              } else {
                self.selectionDirectory[id] = item;
              }
              self.searchItems.csv_selected = Application.API + '/learn/v3/tracks/csv/' + self.track._id + '?authtoken=' + Authorization.getAuthToken().authtoken;
              var ids = [];
              for (var id in self.selectionDirectory) {
                ids.push(self.selectionDirectory[id]._id.toString());
              }
              self.searchItems.csv_selected += '&users=$in,' + ids.length + ',' + ids.join(',');
            },
            isChecked: function(item) {
              if (!item || !item._id) {
                return false;
              }
              return self.selectionDirectory[item._id] ? true : false;
            },
            clear: function() {
              self.selectionDirectory = {};
            }
          };

          const createFilter = function(query_arguments) {
            self.smart_filter = {};
            self.searching = false;
            if (!query_arguments || (typeof query_arguments === 'object' && Object.keys(query_arguments).length === 0)) {
              self.searching = true;
              return;
            }
            if (query_arguments && typeof query_arguments === 'object' && Object.keys(query_arguments).length) {
              self.searching = true;
            }
            self.searchItems.csv_filtered = Application.API + '/learn/v3/tracks/csv/' + self.track._id + '?authtoken=' + Authorization.getAuthToken().authtoken;
            self.searchItems.csv_selected = Application.API + '/learn/v3/tracks/csv/' + self.track._id + '?authtoken=' + Authorization.getAuthToken().authtoken;

            for (var key in query_arguments) {
              self.smart_filter[key] = query_arguments[key];
              self.searchItems.csv_filtered += '&' + key + '=' + encodeURIComponent(query_arguments[key]);
              self.searchItems.csv_selected += '&' + key + '=' + encodeURIComponent(query_arguments[key]);
            }
          };

          self.searchItems = {
            placeholder: self.translations['trackHost.search_placeholder'],
            onQueryPastParticipants: function() {
              self.paginate.pastParticipants.page = 0;
              self.getPastParticipants();
            },
            onQueryActiveParticipants: function() {
              self.paginate.activeParticipants.page = 0;
              self.getParticipants();
            },
            onQuery: function(query_arguments) {
              createFilter(query_arguments);
              self.getParticipantData();
              self.searchItems.onQueryPastParticipants();
              self.searchItems.onQueryActiveParticipants();
            },
            csv_filtered: Application.API + '/learn/v3/tracks/csv/' + Application.navigation.getRouteParameters().id + '?authtoken=' + Authorization.getAuthToken().authtoken,
            csv_selected: Application.API + '/learn/v3/tracks/csv/' + Application.navigation.getRouteParameters().id + '?authtoken=' + Authorization.getAuthToken().authtoken
          };

          self.sortAction = function(type, location) {
            if (self.predicate[location] === type) {
              self.reverse[location] = !self.reverse[location];
              return;
            }
            self.reverse[location] = false;
            self.predicate[location] = type;
          };

          self.usertoken = Authorization.getAuthToken();

          self.isAdmin = function() {
            if (self.usertoken.user.role === 'admin') {
              return true;
            } else {
              return false;
            }
          };

          self.manualCompletion = {
            current: null,
            show: false,
            select: function(uTrack) {
              self.manualCompletion.current = uTrack;
              self.manualCompletion.show = true;
            },
            postSubmit: function() {
              self.smart_filter = {};
              self.searching = false;
              self.searchItems.csv_filtered = Application.API + '/learn/v3/tracks/csv/' + self.track._id + '?authtoken=' + Authorization.getAuthToken().authtoken;
              self.searchItems.csv_selected = Application.API + '/learn/v3/tracks/csv/' + self.track._id + '?authtoken=' + Authorization.getAuthToken().authtoken;
              self.initialize();
            }
          };

          self.sortParam = function(items, parameter, order) {
            order = order === undefined ? 1 : order;

            items.sort(function(a, b) {
              if (a[parameter] < b[parameter]) {
                return (-1 * order);
              }
              if (a[parameter] > b[parameter]) {
                return (1 * order);
              }
              return 0;
            });

            return items;
          };

          self.goToUser = function(user) {
            if (!user || !user._id) {
              return;
            }
            Application.navigation.goTo('/edit/users/' + user._id);
          };

          self.resolveUsers = function() {
            var length = 0;
            var users = null;
            angular.forEach(self.modifications, function(mod) {
              var user = mod.user;
              if (!self.userNames[user]) {
                length++;
                if (!users) {
                  users = '' + user;
                  return;
                }
                users += ',' + user;
              }
            });
            return Users.find({
              fields: '_id,first_name,last_name,full_name,email,image,linked_locations,linked_departments,linked_teams,linked_org_level,linked_grade',
              _id: '$in,' + length + ',' + users
            }).$promise.then(function(users) {
              angular.forEach(users, function(user) {
                self.userNames[user._id] = user;
              });
              self.modLoading = false;
            });
          };

          self.parseUserTracks = function(userTracks) {

            function list(course) {
              if (course.article) {
                self.courseDirectory[course.article] = true;
                return;
              }
              if (course.video) {
                self.courseDirectory[course.video] = true;
                return;
              }
              if (course.file) {
                self.courseDirectory[course.file] = true;
                return;
              }
              if (course.quiz) {
                self.courseDirectory[course.quiz] = true;
                return;
              }
              if (course.scorm) {
                self.courseDirectory[course.scorm] = true;
                return;
              }
              if (course.assessment) {
                self.courseDirectory[course.assessment._id] = true;
                course.assessment.value = course.assessment._id;
                course.assessment.name = course.assessment.title;
                self.assessments.list.push(course.assessment);
                if (!self.assessments.selectedId) {
                  self.assessments.selectedId = course.assessment._id;
                }
                return;
              }
            }

            function numberCompleted(items) {
              var total = 0;
              for (var i = 0; i < items.length; i++) {
                if (self.courseDirectory[items[i]]) {
                  total++;
                }
              }
              return total;
            }
        
            self.totalCourses = 0;
            for (var i = 0; i < self.track.sections.length; i++) {
              for (var j = 0; j < self.track.sections[i].courses.length; j++) {
                list(self.track.sections[i].courses[j]);
                self.totalCourses++;
              }
            }

            for (var i = 0; i < userTracks.length; i++) {

              // Add progress bar data to user track
              var completedItems = numberCompleted(userTracks[i].completed_articles) + numberCompleted(userTracks[i].completed_media) + numberCompleted(userTracks[i].completed_quizzes) + numberCompleted(userTracks[i].completed_assessments) + numberCompleted(userTracks[i].completed_scorm);
              userTracks[i].progress = ~~(completedItems / self.totalCourses * 100);

              // Add duration data to user track
              var started = moment(new Date(userTracks[i].createdAt));
              var last = userTracks[i].completed_date ? moment(new Date(userTracks[i].completed_date)) : moment();
              userTracks[i].duration = last.diff(started, 'days') + ' days';
      
              // Add "active" and "hasCompleted" data to user track
              userTracks[i].active = moment().diff(moment(new Date(userTracks[i].updatedAt))) < dropoffDate ? true : false;
              if (userTracks[i].completed_date) {
                userTracks[i].active = false;
                self.hasCompleted = true;
              }
            }
          };

          // *** Begin Assessments Logic ***

          self.assessments = {
            loading: false,
            ignoreSelected: false,
            showTab: function() {
              if (self.activeTab === 'assessments') {
                return;
              }

              if (!self.assessments.list || !self.assessments.list.length) {
                return;
              }
              // Make sure a selectedId is set
              if (!self.assessments.selectedId) {
                self.assessments.ignoreSelected = true;
                self.assessments.selectedId = self.assessments.list[0]._id;
              }

              // If there is a selectedId and a matching selectedItem set the tab an return
              if (self.assessments.selectedId && self.assessments.selectedItem && self.assessments.selectedItem._id === self.assessments.selectedId) {
                self.activeTab = 'assessments';
                return;
              }

              // If there is a selectedId and a matching selectedItem in the cache, set the item, then the tab an return
              if (self.assessments.cachedFullList[self.assessments.selectedId]) {
                self.assessments.setItem();
                self.activeTab = 'assessments';
                return;
              }

              // Id is set but need to retrieve the new item
              self.assessments.selectNew();
              self.activeTab = 'assessments';
            },
            selectNew: function(id) {
              if (id) {
                self.assessments.ignoreSelected = true;
                self.assessments.selectedId = id;
                setTimeout(function() {
                  self.assessments.ignoreSelected = false;
                }, 800);
              }

              if (self.assessments.cachedFullList[self.assessments.selectedId]) {
                self.assessments.setItem();
                return;
              }

              self.assessments.loading = true;
              Assessments.get({subresource: self.assessments.selectedId, fields: 'title,description,video_assessment,file_assessment,questions,number_of_retakes,allow_retake'}).$promise.then(function(assessment) {
                var chartData = {assessment: assessment._id};

                if (assessment.questions && assessment.questions.length) {
                  chartData.rubricQuestions = [];
                  assessment.questions.forEach(function(question) {
                    if (question.rubric_grading && question.rubric_options && question.rubric_options.length) {
                      chartData.rubricQuestions.push(question);
                    }
                  });
                }

                if (chartData.rubricQuestions && chartData.rubricQuestions.length && assessment.video_assessment) {
                  chartData.activeRubric = chartData.rubricQuestions[0].id;
                  chartData.showRubric = true;
                }

                if (assessment.video_assessment) {
                  self.assessments.setRubricData(chartData);
                }

                if (!assessment.video_assessment) {
                  self.assessments.setStandardData(chartData);
                }


                self.assessments.cachedFullList[assessment._id] = assessment;
                self.assessments.setItem();
              }).catch(function(error) {
                console.log('error in assessment find: ', error);
                self.assessments.loading = false;
              });
            },
            usersOverlay: {},
            list: [],
            tab: 'userAssessments',
            activeUserAssessment: null,
            activeAssessmentScore: null,
            selectedId: null,
            selectedItem: null,
            selectedChart: null,
            csvLink: '',
            cachedFullList: {},
            cachedChartData: {},
            clearScore: function() {
              self.assessments.activeAssessmentScore = null;
            },
            setItem: function() {
              self.assessments.tab = 'userAssessments';
              self.assessments.activeUserAssessment = null;
              self.assessments.activeAssessmentScore = null;
              self.assessments.usersOverlay = {};
              self.assessments.selectedItem = self.assessments.cachedFullList[self.assessments.selectedId];
              self.assessments.csvLink = Application.API + '/learn/v3/assessment-host/user-assessment-csv/' + self.assessments.selectedId + '?authtoken=' + Authorization.getAuthToken().authtoken;
              self.assessments.setChartItem();
              self.assessments.loading = false;
            },
            setChartItem: function() {
              if (self.assessments.cachedChartData[self.assessments.selectedId]) {
                setTimeout(function() {
                  self.assessments.selectedChart = self.assessments.cachedChartData[self.assessments.selectedId];
                  $scope.$apply();
                }, 100);
              }
            },
            toggleRubricChart: function() {
              if (self.assessments.selectedChart && (self.assessments.selectedChart.showRubric || self.assessments.selectedChart.showDistribution)) {
                self.assessments.selectedChart.showRubric = !self.assessments.selectedChart.showRubric;
                self.assessments.selectedChart.showDistribution = !self.assessments.selectedChart.showDistribution;
              }
            },
            setRubricData: function(chartData) {
              AssessmentCharts.rubricData(chartData.assessment, chartData.activeRubric, chartData.rubricQuestions)
                  .then(function(data) {
                    chartData = Object.assign(chartData, data);
                    chartData.rubricData = {};
                    chartData.rubricData.names = data.names;
                    chartData.rubricData.mean_values = data.mean_values;
                    chartData.rubricData.rubric_ids = data.rubric_ids;
                    self.assessments.cachedChartData[chartData.assessment] = chartData;
                    self.assessments.setChartItem();
                  }).catch(function(error) {
                console.log('error: ', error);
              });
            },
            setStandardData: function(chartData) {
              AssessmentCharts.standardData(chartData.assessment)
                  .then(function(data) {
                    chartData = Object.assign(chartData, data);
                    self.assessments.cachedChartData[chartData.assessment] = chartData;
                    self.assessments.setChartItem();
                  }).catch(function(error) {
                console.log('error: ', error);
              });
            }
          };

          $scope.$watch('host.assessments.selectedId', function(newVal, oldVal) {
            if (self.assessments.ignoreSelected) {
              self.assessments.ignoreSelected = false;
              return;
            }
            if (newVal && newVal !== oldVal) {
              self.assessments.selectNew(self.assessments.selectedId);
            }
          });

          // *** End Assessments Logic ***

          // Build search filtering


          const getIdList = (filter) => {
            const idList = filter.split(",").filter(string => string.length >= 23);
            return {'$in': idList};
          }

          self.privacyFilter = () => {
            let filtered_query = {};
            if (self.smart_filter.privacy_locations && self.smart_filter.privacy_locations.length > 0) {
              filtered_query.linked_locations = getIdList(self.smart_filter.privacy_locations);
            }
            if (self.smart_filter.privacy_departments && self.smart_filter.privacy_departments.length > 0) {
              filtered_query.linked_departments = getIdList(self.smart_filter.privacy_departments);
            }
            if (self.smart_filter.privacy_teams) {
              filtered_query.linked_teams = getIdList(self.smart_filter.privacy_teams);
            }
            if (self.smart_filter.privacy_org_levels && self.smart_filter.privacy_org_levels.length > 0) {
              filtered_query.linked_org_level = getIdList(self.smart_filter.privacy_org_levels);
            }
            if (self.smart_filter.privacy_grades && self.smart_filter.privacy_grades.length > 0) {
              filtered_query.linked_grade = getIdList(self.smart_filter.privacy_grades);
            }
            if (self.smart_filter.groups && self.smart_filter.groups.length > 0) {
              filtered_query.groups = getIdList(self.smart_filter.groups);
            }
            if (self.smart_filter['$or']) {
              const namesearch_arguments = self.smart_filter['$or'].split(',');
              if (namesearch_arguments[4]) {
                if (Object.keys(filtered_query).length) {
                  const queries = {'$or': [filtered_query, {full_name: {'$regex': namesearch_arguments[4], '$options': 'i'}}]};
                  return queries;
                } 
                filtered_query.full_name = {'$regex': namesearch_arguments[4], '$options': 'i'};
              }
            }
            return filtered_query;
          }

          // Request Participants

          const participantsQueryFields = 'track,user,completed_articles,completed_media,completed_assessments,completed_quizzes,completed_scorm,completed_date,updatedAt,createdAt';
          const participantsQueryUserPopulateFields = '_id,first_name,last_name,full_name,email,image,linked_locations,linked_departments,linked_teams,linked_org_level,linked_grade';

          self.getParticipants = function() {
            const filter = self.privacyFilter();
            return UserTracks.filter({
              track: routeParameters.id,
              userFilter: filter,
              paginate: {
                page: self.paginate.activeParticipants.page,
                perPage: self.paginate.activeParticipants.perPage
              },
              fields: participantsQueryFields,
              'user-populate': participantsQueryUserPopulateFields
            }, function(data) {
              self.userTracks = data;
              self.paginate.activeParticipants.pageContents = data; 
              self.paginate.checkPaging(self.paginate.activeParticipants);
              if (self.track) {
                self.parseUserTracks(self.paginate.activeParticipants.pageContents);
              }
              self.loadingUserTracks = false;
            }, function(error) {
              console.log('Error occured getting track ', routeParameters.id, error);
              Application.notifications.setError(self.translations['trackHost.unable_to_get_track']);
            }).$promise;
          };

          self.getPastParticipants = function() {
            const filter = self.privacyFilter();
            return UserTracks.filter({
              track: routeParameters.id,
              userFilter: filter,
              paginate: {
                page: self.paginate.pastParticipants.page,
                perPage: self.paginate.pastParticipants.perPage
              },
              completed: true,
              fields: participantsQueryFields,
              'user-populate': participantsQueryUserPopulateFields
            }, function(data) {
              self.completedUserTracks = data;
              self.paginate.pastParticipants.pageContents = data;
              self.paginate.checkPaging(self.paginate.pastParticipants);
              if (self.track) {
                self.parseUserTracks(self.paginate.pastParticipants.pageContents);
              }
              self.loadingUserTracks = false;
            }, function(error) {
              console.log('Error occured getting track ', routeParameters.id, error);
              Application.notifications.setError(self.translations['trackHost.unable_to_get_track']);
            }).$promise;
          }

          self.getParticipantData = function() {
            const filter = self.privacyFilter();
            return UserTracks.count({
              track: routeParameters.id,
              userFilter: filter
            }, function(data) {
              self.circleStats = data;
              self.paginate.activeParticipants.getNumberOfPages();
              self.paginate.pastParticipants.getNumberOfPages();
            }).$promise
          };

          // Pagination

          self.paginate = {
            activeParticipants: {
              page: 0, 
              perPage: 20,
              noNext: true,
              pageContents: [],
              numberOfPages: 0,
              getNumberOfPages: () => {
                self.paginate.activeParticipants.numberOfPages = self.circleStats.activeParticipants / self.paginate.activeParticipants.perPage
              }
            },
            pastParticipants: {
              page: 0, 
              perPage: 20,
              noNext: true,
              pageContents: [],
              numberOfPages: 0,
              getNumberOfPages: () => {
                self.paginate.pastParticipants.numberOfPages = Math.ceil(self.circleStats.completedParticipants / self.paginate.pastParticipants.perPage)
              }
            },
            next: function(participantPageObject, participantFunction) {
              participantPageObject.page++;
              participantFunction();
            },
            previous: function(participantPageObject, participantFunction) {
              participantPageObject.page--;
              participantFunction();
            },
            checkPaging: function(participantPageObject) {
              if (participantPageObject.pageContents.length < participantPageObject.perPage) {
                participantPageObject.noNext = true;
                return;
              }
              if (participantPageObject.numberOfPages - 1 === participantPageObject.page) {
                participantPageObject.noNext = true;
                return;
              }
              if (participantPageObject.pageContents.length === participantPageObject.perPage) {
                participantPageObject.noNext = false;
              }
            }
          }

          self.initialize = async function() {

            self.loadingTrack = true;
            self.loadingUserTracks = true;
            self.modLoading = true;
            if (!routeParameters.id && !$scope.fullData) {
              console.log('No id specified');
              Application.navigation.goToHome();
              return;
            }

            try {

              const data = await Tracks.get({
                subresource: routeParameters.id,
                fields: 'name,company,creator_notes,sections,average_rating,rating_configuration',
                'sections.courses.assessment-populate': '_id,title,type,video_assessment'
              }).$promise;

              if (data.company !== Authorization.getAuthToken().company._id) {
                self.noEdit = true;
              }
              self.track = data;
              self.csvDownload = Application.API + '/learn/v3/tracks/csv/' + self.track._id + '?authtoken=' + Authorization.getAuthToken().authtoken;
              self.allowRating = self.track && self.track.rating_configuration && self.track.rating_configuration.allow_rating;
              if (self.track.average_rating) {
                var outOfFive = Math.round(self.track.average_rating * 5) / 100;
                if (outOfFive) {
                  self.rating = outOfFive;
                }
              }
              $scope.$apply();
            } catch (error) {
              console.log('Error occured getting track ', routeParameters.id, error);
              Application.notifications.setError(self.translations['trackHost.unable_to_get_track']);
            };
            
            await Promise.all([self.getParticipantData(), self.getParticipants(), self.getPastParticipants()]);
            
            Analyze.modifications({
              subresource: 'tracks',
              itemid: routeParameters.id,
              users: 'all'
            }).$promise.then(function(data) {
              self.modifications = data;
              self.resolveUsers();
            });
            
            self.loadingTrack = false;
            $scope.$apply();
          };

          self.initialize();

          $translate([
            'trackHost.search_placeholder',
            'trackHost.unable_to_get_track',
            'trackHost.unable_to_get_track',
            'trackHost.open_assignments',
            'trackHost.total_participants',
            'trackHost.all_time',
            'trackHost.num_completed',
            'trackHost.num_still_completing',
            'trackHost.average_days_to_complete'
          ]).then(function (translations) {
            self.translations = translations;
          })
        }],
      controllerAs: 'host'
    };
  }]);
